module.exports = __webpack_public_path__ + "img/staff.5b867b32.svg";